export { BuggyKindermanRamage } from './buggy-kinderman-ramage';
export { BoxMuller } from './box-muller';
export { AhrensDieter} from './ahrens_dieter';
export { Inversion } from './inversion';
export { KindermanRamage }  from './kinderman-ramage';
export { IRNGNormal } from './inormal-rng';



// WEBPACK FOOTER //
// ./src/lib/rng/normal/index.ts